export default () => ({
  startAnimation() {
    let brandingDiv = document.getElementById('mobile-branding');
    let brandingImg = brandingDiv.querySelector('img');
    let originalHeight = window.innerHeight; // Get the viewport height

    // Set the initial top position of the image to be -100% of viewport height (so it's hidden above)
    brandingImg.style.bottom = `-${originalHeight}px`;

    // Function to adjust the top position of the image dynamically as the user scrolls
    function adjustImagePosition() {
      let rect = brandingDiv.getBoundingClientRect();

      // Calculate how much the user has scrolled relative to the top of the banner
      let scrollOffset = originalHeight - rect.top;


      // Update the top position of the image relative to scroll position
      //brandingImg.style.bottom = `${scrollOffset}px`;

      // Continue adjusting the image position as long as the banner is visible
      if (rect.bottom > 0) {
        requestAnimationFrame(adjustImagePosition);
      }
    }

    // Start the scroll-based animation
    adjustImagePosition();
  }
})
